'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'tiny-warning';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, n, o = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(n = 0; n < i.length; n++)r = i[n], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
    return o;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, n, o = {}, i = Object.keys(e);
    for(n = 0; n < i.length; n++)r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
    return o;
}
let o = {
    h1: 'x4large',
    h2: 'x3large',
    h3: 'x2large',
    h4: 'large',
    h5: 'standard',
    h6: 'standard'
}, i = {
    h1: 'bold',
    h2: 'bold',
    h3: 'bold',
    h4: 'bold',
    h5: 'bold',
    h6: 'bold'
};
function get(e, t) {
    if (null != t && e && t in e) return e[t];
}
const Typography = renderWithRef('Typography', null, (n, a)=>{
    let { children: p, noWrap: l = false, truncate: c = false } = n, s = _object_without_properties(n, [
        "children",
        "noWrap",
        "truncate"
    ]), u = new Set(), d = s.as || s.component;
    return 'string' == typeof d && d in i && u.add('swan-heading'), l && u.add('swan-text-no-wrap'), c && u.add('swan-text-truncate'), 'string' == typeof d && d in i && t(n.__dangerouslySuppressWarning, `Typography rendered as ${d}: Consider using SWAN's heading component <${d.toUpperCase()}>`), jsx(RenderComp, {
        root: "div",
        forwardedRef: a,
        classNames: u,
        props: _object_spread({
            fontSize: n.fontSize || get(o, d) || void 0,
            fontWeight: n.fontWeight || get(i, d)
        }, s),
        children: p
    });
});

export { Typography };
